import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const StockAgingAnalysis = {
	name: NAME,
	apiProvider,
	router,
};
